'use strict';

customerZone

/**
 * A directive that injects an invisible recaptcha into the page.  The invisible recaptcha will only work if
 * the element around the site of injection is visible.
 *
 * The directive binds a handler to the scope at a given point (e.g. `<div recaptcha="controller.myRecaptcha" />`).
 * To use the recaptcha, invoke execute() on the handler, which will return a promise to the recaptcha response.
 * In the example above, that would become `myRecaptcha.execute().then(function(response){...});`.
 *
 * The directive takes care of reusing the same recaptcha or timing out, so that the invoker does not need to
 * care about these points.
 */
.directive('recaptcha', ['$q', '$log', '$timeout', 'utils', 'vcRecaptchaService',
    function($q, $log, $timeout, utils, vcRecaptcha){

        return {
            restrict: 'A',
            scope: {},
            link: function(scope, element, attrs) {

                var widgetId,
                    readyPromise,
                    responsePromise;

                // inject into the parent scope using the passed expression
                scope.handler = utils.getOrCreate(scope.$parent, attrs.recaptcha, function(){});

                var position = attrs['recaptchaPosition'];

                var init = function() {
                    readyPromise = vcRecaptcha.create(element[0], {
                        callback: onResponseReceived,
                        badge: position || 'bottomleft',
                        size: 'invisible',
                        'expired-callback': onResponseExpired
                    }).then(function (_widgetId_) {
                        widgetId = _widgetId_;
                    });
                };

                var reset = function(delay){
                    readyPromise = $timeout(function(){
                        vcRecaptcha.reload(widgetId);
                        responsePromise = undefined;
                    }, delay);
                };

                var executeCaptcha = function(){
                    if (!responsePromise) {
                        responsePromise = $q.defer();
                        vcRecaptcha.execute(widgetId);
                    }
                    return responsePromise.promise;
                };

                var onResponseReceived = function(response){
                    if (!responsePromise){
                        $log.debug('Callback fired with '+[].map.call(arguments, function(e){
                            return JSON.stringify(e);
                        }).join(', '));
                        throw new Error('Callback fired when no response requested');
                    }
                    responsePromise.resolve(response);
                };

                var onResponseExpired = function(){
                    responsePromise = undefined;
                };

                /**
                 * Execute the recaptcha to get a response which can then be sent along with a request to prove the
                 * end-user is human.  In some cases, this will trigger a challenge for the end-user.
                 * @return A promise to the recaptcha response.
                 */
                scope.handler.execute = function(){
                    return readyPromise
                        .then(executeCaptcha)
                        .then(function(response){
                            /* as soon as this promise is consumed, reload the captcha.
                             * this prevents us from using results twice */
                            reset(501);
                            /* the 501ms delay is related to an issue with google recaptcha
                             * which will generate an error* if the widget is reloaded within
                             * half a second after use.  We effectively prevent more than two
                             * captchas per second this way, which probably makes sense anyway. */
                            return response;
                        });
                };

                init();
            }
        };

    }]);
